import { render } from "./GlobalDropOverlay.vue?vue&type=template&id=b8bc72b0&scoped=true"
import script from "./GlobalDropOverlay.vue?vue&type=script&lang=js"
export * from "./GlobalDropOverlay.vue?vue&type=script&lang=js"

import "./GlobalDropOverlay.vue?vue&type=style&index=0&id=b8bc72b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8bc72b0"]])

export default __exports__